// 分页默认大小
export const PAGE_SIZE = 20;
// ajax 请求成功 code
export const SUCCESS_CODE = "000000";
